import api from "../index";

export const GetTermsAndConditionApi = () => api.get(`TermsAndCondition/get`);
export const CreateTermsAndConditionApi = (data, apiHeader) => api.post(`TermsAndCondition/create`, data, apiHeader);
export const UpdateTermsAndConditionApi = (id, data, apiHeader) => api.put(`TermsAndCondition/update/${id}`, data, apiHeader);
export const UpdateStatusTermsAndConditionApi = (id, status) => api.put(`TermsAndCondition/${id}/status?${status}`);

export const GetTermsAndConditionReportApi = (params) => api.get(`TermsAndCondition/accepted-users?${params}`);